import React from "react";
import moment from 'moment';
import shortenText from '../../utils/shortenText';
import undraw from '../../Assets/Icons/undraw_events_2p66.svg';
const LandScapeEvent = ({
  event
}) => {
  console.log(event, 'this is teh event')
  const titleLength = event?.thumbnail ? 72 : 80;

  return (
    <> 
{event &&  <div className="w-full h-full flex items-center">
      {
        <div className="py-2 mr-4 flex-shrink-0 w-1/4 h-full">
          <div className="w-full h-full  rounded overflow-hidden flex items-start relative">
            <img
            onError={() => event.thumbnail = undraw}
              src={
              event?.content?.banner_image?.filename ||  undraw
              }
              alt="banner"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      }
      <div className="flex-grow ">
        <span className="leading-6 text-metal text-10px">
          {!!event?.content?.date && moment(event?.content?.date).format('MMMM Do YYYY, h:mm a')}
        </span>
        <h6 className="font-bold leading-6 text-xs md:text-sm lg:text-semibold capitalize">
          {!!event?.name && shortenText(event?.name, titleLength)}
        </h6>
        <div className="text-xs mt-1 font-poppins">
            {shortenText(event?.content?.short_brief, 120)}
        </div>
      </div>
    </div>
}
</>
  );
};

export default LandScapeEvent;
